import { Map } from 'immutable';
import {
    EMPLOYEE_COUNT,
    OVERRIDE_POINTS,
    MANUAL_AWARD_POINTS,
    NO_CALL_OFF_POINTS,
    NO_CALL_OFF_SHIFTS,
    ON_TIME_POINTS,
    PARTICIPATION,
    QUARTERLY,
    REWARD_BUDGET,
    REWARD_VALUE,
    SHIFTS_PICKED_UP,
    SURVEY,
    UPDATE_ALL_THE_THINGS
} from '../actions/types';

const defaultState = Map({
    EMPLOYEE_COUNT: 100,
    OVERRIDE_POINTS: 250,
    MANUAL_AWARD_POINTS: 500,
    NO_CALL_OFF_POINTS: 25,
    NO_CALL_OFF_SHIFTS: 10,
    ON_TIME_POINTS: 2,
    PARTICIPATION: 75,
    QUARTERLY: 50,
    REWARD_BUDGET: 500,
    REWARD_VALUE: 11,
    SHIFTS_PICKED_UP: 0, // Temporarily set to 0 for 0.8.2
    SURVEY: 5
});

const initialState = calculateState(defaultState);

function calculateState(state) {
    let AVG_MAX_NUM_SHIFTS = 20,
        AVG_MAX_NUM_SHIFTS_PICKED_UP = 10,
        AVG_MAX_NUM_SURVEYS = 4;

    // Raw calculations
    let valueAveTenure = state.get(EMPLOYEE_COUNT) * state.get(QUARTERLY) / 3,
        // For Max values, calculate for all employees based on average opportunities in one month
        valueMaxNoCallOffs = state.get(EMPLOYEE_COUNT) * state.get(NO_CALL_OFF_POINTS) * (AVG_MAX_NUM_SHIFTS / state.get(NO_CALL_OFF_SHIFTS)),
        valueMaxOnTime = state.get(EMPLOYEE_COUNT) * state.get(ON_TIME_POINTS) * AVG_MAX_NUM_SHIFTS,
        valueMaxShiftsPickedUp = state.get(EMPLOYEE_COUNT) * state.get(SHIFTS_PICKED_UP) * AVG_MAX_NUM_SHIFTS_PICKED_UP,
        valueMaxSurvey = state.get(EMPLOYEE_COUNT) * state.get(SURVEY) * AVG_MAX_NUM_SURVEYS,
        valueMaxTenure = state.get(EMPLOYEE_COUNT) * state.get(QUARTERLY),
        // How many rewards can be given in one month, based on budget and reward value
        valueRewardsPerMonth = state.get(REWARD_BUDGET) / state.get(REWARD_VALUE);
    // Automatic aggregate calculations
    let valueMaxTotalPoints = valueAveTenure + valueMaxNoCallOffs + valueMaxOnTime + valueMaxSurvey + valueMaxShiftsPickedUp,
        valuePointsPerReward = valueMaxTotalPoints / valueRewardsPerMonth,
        valueRoundedPointsPerReward = Math.ceil(valuePointsPerReward / 10) * 10,
        valueRoundedPointsPerRewardDistributed = Math.floor(valueMaxTotalPoints / valueRoundedPointsPerReward) * state.get(REWARD_VALUE);
    // Overridden aggregate calculations
    let valueOverrideRewardsPerMonth = valueMaxTotalPoints / state.get(OVERRIDE_POINTS),
        valueOverrideRewardsPerMonthDistributed = valueOverrideRewardsPerMonth * state.get(REWARD_VALUE),
        valueOverrideRewardsPerMonthStyle = valueOverrideRewardsPerMonthDistributed > state.get(REWARD_BUDGET) ? 'danger' : 'success';
    // Percent participation estimates
    let valueMaxTotalPointsEst = valueAveTenure + (valueMaxNoCallOffs + valueMaxOnTime + valueMaxSurvey + valueMaxShiftsPickedUp) * (state.get(PARTICIPATION) / 100),
        valueOverrideRewardsEst = valueMaxTotalPointsEst / state.get(OVERRIDE_POINTS),
        valueOverrideRewardsValueEst = valueOverrideRewardsEst * state.get(REWARD_VALUE),
        valueOverrideRewardsWithManualAwardsValueEst = (state.get(MANUAL_AWARD_POINTS) / state.get(OVERRIDE_POINTS)) * state.get(REWARD_VALUE),
        valueRewardsDistributedEst = valueMaxTotalPointsEst / valuePointsPerReward,
        valueRewardsDistributedValueEst = valueRewardsDistributedEst * state.get(REWARD_VALUE),
        valueRewardsDistributedValueWithManualAwardsEst = (state.get(MANUAL_AWARD_POINTS) / valueRoundedPointsPerReward) * state.get(REWARD_VALUE);

    return state.merge(Map({
        valueAveTenure: valueAveTenure,
        valueMaxNoCallOffs: valueMaxNoCallOffs,
        valueMaxOnTime: valueMaxOnTime,
        valueMaxShiftsPickedUp: valueMaxShiftsPickedUp,
        valueMaxSurvey: valueMaxSurvey,
        valueMaxTenure: valueMaxTenure,
        valueMaxTotalPoints: valueMaxTotalPoints,
        valueMaxTotalPointsEst: valueMaxTotalPointsEst,
        valueOverrideRewardsEst: valueOverrideRewardsEst,
        valueOverrideRewardsPerMonth: valueOverrideRewardsPerMonth,
        valueOverrideRewardsPerMonthDistributed: valueOverrideRewardsPerMonthDistributed,
        valueOverrideRewardsPerMonthStyle: valueOverrideRewardsPerMonthStyle,
        valueOverrideRewardsValueEst: valueOverrideRewardsValueEst,
        valueOverrideRewardsWithManualAwardsValueEst: valueOverrideRewardsWithManualAwardsValueEst,
        valuePointsPerReward: valuePointsPerReward,
        valueRewardsDistributedEst: valueRewardsDistributedEst,
        valueRewardsDistributedValueEst: valueRewardsDistributedValueEst,
        valueRewardsDistributedValueWithManualAwardsEst: valueRewardsDistributedValueWithManualAwardsEst,
        valueRewardsPerMonth: valueRewardsPerMonth,
        valueRoundedPointsPerReward: valueRoundedPointsPerReward,
        valueRoundedPointsPerRewardDistributed: valueRoundedPointsPerRewardDistributed
    }));
}

export default function(state = initialState, action) {
    const { type, value } = action;
    switch (type) {
        case (UPDATE_ALL_THE_THINGS):
            return calculateState(state.merge(value));
        default:
            return calculateState(state.set(type, Number(value)));
    }
}
